import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { ToastrService } from 'ngx-toastr';
import { Helpers } from '../../../../helpers';
import { Globals } from '../../helpers';
import { Content, User } from '../../models';
import { AuthenticationService, ContentService, StructuredService } from '../../services';

interface EditContentDialogData {
  content: Content;
}
@Component({ templateUrl: 'edit-content.dialog.html' })
export class EditContentDialog implements OnInit {
  public editContentForm;
  public currentUser: User;
  public grades;
  public subjects;
  public topics;
  constructor(
    private toastr: ToastrService,
    private structuredService: StructuredService,
    public globals: Globals,
    private authService: AuthenticationService,
    private contentService: ContentService,
    public dialogRef: MatDialogRef<EditContentDialog>,
    @Inject(MAT_DIALOG_DATA) public data: EditContentDialogData) { }
  public ngOnInit(): void {
    this.currentUser = this.authService.getCurrentUserCookie();
    this.getDistinctTags();
    this.fillEditForm();
  }

  public onEditContentFormSubmit(content) {
    Helpers.setLoading(true);
    const c: Content = {
      description: content['description-input'],
      language: content['lang-input'],
      name: content['name-input'],
      grade: content['grade-input'],
      subject: content['subject-input'],
      topics: content['topics-input'],
      type: content['type-input'],
      visibility: content['visibleType-input'],
      featured: content['featured-input'],
      restrictKiwix: content['restrictKiwix-input'],
    };

    if (c.topics && c.topics.length) {
      c.topics = c.topics.map((tag: any) => {
        if (tag !== null && typeof tag === 'object') {
          if ('_id' in tag) { return tag._id; }
          if ('value' in tag) { return tag.value; }
        }
        console.log('expected to see either _id or value', tag);
        return tag;
      });
    }

    this.contentService.update(this.data.content._id, c).subscribe((data) => {
      this.toastr.success('Content successfully updated');
      this.dialogRef.close(data);
      Helpers.setLoading(false);
    });
  }
  private fillEditForm() {
    const gradeId = this.data.content.grade && this.data.content.grade._id ? this.data.content.grade._id : null;
    const subjectId = this.data.content.subject && this.data.content.subject._id ? this.data.content.subject._id : null;
    const topicIds = this.data.content.topics && this.data.content.topics.length ?
      this.data.content.topics.map((topic) => ({ _id: topic._id, name: topic.data.name, type: topic.type })) : [];

    // this.data.content.topics.map((topic) => topic._id) : [];
    // this.data.content.topics.map((topic) => ({ _id: topic._id, name: topic.data.name })) : []
    this.editContentForm = new FormGroup({
      'name-input': new FormControl(this.data.content.name, [Validators.required]),
      'description-input': new FormControl(this.data.content.description, []),
      'grade-input': new FormControl(gradeId, []),
      'subject-input': new FormControl(subjectId, []),
      'topics-input': new FormControl(topicIds, []),
      'visibleType-input': new FormControl(this.data.content.visibility, [Validators.required]),
      'featured-input': new FormControl(this.data.content.featured, []),
      'lang-input': new FormControl(this.data.content.language, [Validators.required]),
      'restrictKiwix-input': new FormControl(this.data.content.restrictKiwix, []),
    });
  }
  private getDistinctTags() {
    this.structuredService.getGenericFilters().subscribe((data) => {
      if (data) {
        if (data.grades) {
          this.grades = data.grades.map((grade) => ({ _id: grade._id, name: grade.data.name, type: grade.type }));
        }
        if (data.subjects) {
          this.subjects = data.subjects.map((subject) => ({ _id: subject._id, name: subject.data.name, type: subject.type }));
        }
        if (data.topics) {
          this.topics = data.topics.map((topic) => ({ _id: topic._id, name: topic.data.name, type: topic.type }));
        }
      }
    });
  }
}
